export default __webpack_public_path__ + "static/media/computer_skills.ee6dc969.jpg";